module.exports = __webpack_public_path__ + "assets/img/bg.97218fb3.png";